import { useEffect, useState } from "react";

import { PlusOutlined } from "@ant-design/icons";
import { Button, Input } from "antd";

import { VerticalContainer } from "../../../components/styled";
import VeiculosTable from "../../../components/veiculos/table";
import history from "../../../routes/history";
import { deleteVeiculo, getVeiculos } from "../../../services/veiculos";

const { Search } = Input;

export default function ListVeiculos() {
  const [filter, setFilter] = useState("");
  const [veiculos, setVeiculos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(10);
  const getVeiculosPaginated = async () => {
    setLoading(true);
    try {
      const veiculoGet = await getVeiculos(page, filter);
      setVeiculos(veiculoGet);
      setTotal(veiculoGet.length);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getVeiculosPaginated();
  }, [page, filter]);

  const handleTableChange = (pagination) => {
    setPage(pagination.current);
  };
  async function confirm(record) {
    await deleteVeiculo(record.id);
    await getVeiculosPaginated();
  }

  const onSearch = (value) => {
    setFilter(value);
  };
  const onChange = (e) => {
    if (!e.target.value) setFilter("");
  };

  return (
    <>
      <VerticalContainer>
        <Search
          onChange={onChange}
          style={{ width: "50%" }}
          placeholder="Pesquisar veiculo..."
          enterButton="Pesquisar"
          onSearch={onSearch}
          size="middle"
        />
        <br />
        <Button
          type="dashed"
          onClick={() => {
            history.push("/adicionar-veiculo");
          }}
          style={{ width: "100%!important" }}
          block
        >
          <PlusOutlined />
          Adicionar veículo
        </Button>
        <br />
        <VeiculosTable
          loading={loading}
          handleTableChange={handleTableChange}
          veiculos={veiculos}
          total={total}
          confirm={confirm}
        />
      </VerticalContainer>
    </>
  );
}
